import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {};

export const NumberEmptyState: React.FC<IProps> = () => {
  return (
    <Flex flexDirection={'column'}>
      <Text textStyle={'textBody'}>No data available</Text>
    </Flex>
  );
};
